// Shared by AddProduct/UpdateProduct's canvas watermarking — draws the
// actual brand logo (not rendered text) onto item photos, faded so it reads
// as a watermark rather than a sticker. Mirrors the backend's PHP/GD version
// (see PS_Image::_watermark_file()) as closely as canvas vs GD allow.
const LOGO_URL = '/external_assets/img/motor_logo_watermark.png';
const OPACITY = 0.45;
const WIDTH_RATIO = 0.6;

let logoPromise = null;
function loadLogo() {
    if (!logoPromise) {
        logoPromise = new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = LOGO_URL;
        });
    }
    return logoPromise;
}

export async function drawWatermark(ctx, canvas) {
    const logo = await loadLogo();
    const logoWidth = canvas.width * WIDTH_RATIO;
    const logoHeight = logoWidth * (logo.height / logo.width);
    const x = (canvas.width - logoWidth) / 2;
    const y = (canvas.height - logoHeight) / 2;
    ctx.globalAlpha = OPACITY;
    ctx.drawImage(logo, x, y, logoWidth, logoHeight);
    ctx.globalAlpha = 1;
}
